import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import Box from '@mui/material/Box';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import Iconify from '../../../src/components/Iconify';
//intl
import { useIntl } from 'react-intl';

//product images
interface Props {
    image: string;
    id: number;
    isFavorite: boolean;
    percentageOff: number;
    price: number;
    productDescription: string;
    productName: string;
    discountedPrice: number;
    images: Array<string>;
    mbBetweenCards?: number;
}

export default function ProductCard(props: Props) {
    const intl = useIntl();
    const { images, image, id, isFavorite, percentageOff, price, productDescription, productName, mbBetweenCards } = props;
    const navigate = useNavigate();

    const handleSubmit = (id: any) => {
        navigate('/product_detail', { state: { props } });
    }

    return (
        <Card sx={{ mb: (mbBetweenCards || 3), boxShadow: 0, display: 'flex', justifyContent: 'center' }}>
            <ButtonBase sx={{ display: 'block' }} onClick={() => handleSubmit(id)}>
                <Box
                    component="img"
                    sx={{
                        width: 300,
                        height: 400,
                        maxHeight: { xs: 200, sm: 400 },
                        maxWidth: { xs: 150, sm: 300 },
                    }}
                    src={image}
                />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box>
                        <Typography variant='subtitle1' fontSize={{sm: 16, xs:12}} sx={{ color: 'black', fontWeight: 400 }}>
                            {productName}
                        </Typography>
                    </Box>
                    <Box>
                        <Iconify icon={isFavorite ? "flat-color-icons:like" : "akar-icons:heart"}
                            sx={{ width: "24", height: "24", color: "#000", float: 'right' }} />
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <Typography variant='subtitle2' fontSize={{sm: 14, xs:12}} sx={{ color: '#626262', mt: {sm: 1, xs: 0} }}>
                        {intl.formatMessage({id: 'p-details.texto-1', defaultMessage: 'Fall Collection'})}
                    </Typography>
                    <Typography variant='subtitle1' fontSize={{sm: 16, xs:14}} sx={{ color: 'black', mt: {sm: 1, xs: 0} }}>
                        $ {price.toFixed(2)}
                    </Typography>
                </Box>
            </ButtonBase>

        </Card>
    )

}